import { useFormik } from 'formik';
// mantine
import { Button, UnstyledButton, Collapse, Checkbox } from '@mantine/core';
// icons
import { Upload } from 'lucide-react';
import { useDisclosure } from '@mantine/hooks';
// utils

type ExportAgentButtonFormPropsType = {
    handleSubmit: (data: TAgentData) => Promise<unknown>;
    isLoading: boolean;
};

export type TAgentData = {
    export_akb: boolean;
    export_customer_attributes: boolean;
};

const ExportAgentButtonForm = ({
    handleSubmit,
    isLoading
}: ExportAgentButtonFormPropsType) => {
    const [isOpened, { toggle }] = useDisclosure(false);

    const initialValues: TAgentData = {
        export_akb: true,
        export_customer_attributes: true
    };

    const formik = useFormik({
        initialValues,
        onSubmit: (formData: TAgentData) => {
            handleSubmit(formData)
                .catch(console.error)
                .finally(() => {
                    formik.setSubmitting(false);
                });
        }
    });

    return (
        <form autoComplete="off" onSubmit={formik.handleSubmit}>
            <Button
                className="mb-4"
                leftSection={<Upload />}
                loading={isLoading}
                type="submit"
            >
                Export
            </Button>

            <UnstyledButton
                className="text-xs text-blue-6 mb-4 block"
                onClick={toggle}
            >
                Advanced settings
            </UnstyledButton>
            <Collapse in={isOpened}>
                <div className="flex flex-col gap-3">
                    <Checkbox
                        checked={formik.values.export_akb}
                        description="If false, AKB files are excluded from the export."
                        label="Export AKB files"
                        name="export_akb"
                        onChange={formik.handleChange}
                    />
                    <Checkbox
                        checked={formik.values.export_customer_attributes}
                        description="If false, customer attribute YAML files are excluded from the export."
                        label="Export Customer Attributes"
                        name="export_customer_attributes"
                        onChange={formik.handleChange}
                    />
                </div>
            </Collapse>
        </form>
    );
};

export default ExportAgentButtonForm;
